import { createContext, useContext } from "react";

export interface ReferralParams {
  regular_referee_count: number;
  pro_referee_count: number;
  balance: number;
}

export interface GlobalStoreParams {
  user_type: number;
  closest_airport: string;
  email: string;
  route_range: number;
  route_calendar_range: number;
  flight_range: number;
  show_upsell: boolean;
  expire_date: string;
  referral_code: string;
  referral: ReferralParams;
  influencer: boolean;
  user_preference: {
    cards: string[];
    programs: string[];
    cabins: string;
    percent_premium: number;
    real_time_search_table_type: number;
  };
  load: boolean;
  local_expire_date?: number;
  promotion: any | undefined;
  real_time_search_block: boolean;
  hard_real_time_search_block: boolean;
  persistStore: GlobalStoreParams;
}

export const globalStoreInitData = {
  user_type: 0,
  closest_airport: "",
  email: "",
  route_range: 7,
  route_calendar_range: 60,
  flight_range: 3,
  show_upsell: false,
  expire_date: "",
  referral_code: "",
  influencer: false,
  referral: { regular_referee_count: 0, pro_referee_count: 0, balance: 0 },
  user_preference: {
    cards: [],
    programs: [],
    cabins: "",
  },
  load: false,
  promotion: undefined,
  real_time_search_block: false,
  hard_real_time_search_block: false,
  persistStore: {},
};

export const GlobalStoreContext = createContext<GlobalStoreParams>(globalStoreInitData);

export const useGlobalStoreContext = () => {
  return useContext(GlobalStoreContext);
};
